import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { ModuleOnMultipleValueUpdate } from '../../Module/_actions/ModuleActions';
import Transformer, { Props } from '../_components/Transformer';

const mapStateToProps = (store:Store, props:Props) => ({
	documentOffsetX: store.getIn(['create', 'document', 'offsetX']),
	documentOffsetY: store.getIn(['create', 'document', 'offsetY']),
	documentWidth: store.getIn(['create', 'document', 'width']),
	documentHeight: store.getIn(['create', 'document', 'height']),
	documentDPI: store.getIn(['create', 'document', 'dpi']),
	shiftDown: store.getIn(['create','hid','shiftDown']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	updater: (moduleId:string, updates:{[key:string] : any}) => dispatch(ModuleOnMultipleValueUpdate(moduleId, updates)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{ forwardRef: true}
)(Transformer);